import bugReport from 'api/BugReport/reducer'
import channels from 'api/Channels/reducer'
import companies from 'api/Companies/reducer'
import countries from 'api/Countries/reducer'
import group from 'api/Group/reducer'
import omsOrigins from 'api/OmsOrigins/reducer'
import owners from 'api/Owners/reducer'
import saleTypes from 'api/SaleTypes/reducer'
import store from 'api/Store/reducer'
import stores from 'api/Stores/reducer'
import system from 'api/System/reducer'
import user from 'api/User/reducer'
import channelsFloorspaceModal from 'ChannelsFloorspaceModal/reducer'
import channelsType from 'ChannelsTabs/reducer'
import clubCardModal from 'ClubCardModal/reducer'
import componentsCompleteness from 'components/Completeness/reducer'
import storeDetails from 'components/Store/reducer'
import { connectRouter } from 'connected-react-router'
import datePicker from 'DatePickerDialog/reducer'
import expanded from 'expanded/reducer'
import countries1, { completeness } from 'home/reducer'
import isListDetailsOpen from 'ListDetails/reducer'
import myResults from 'MyResults/reducer'
import notifications from 'Notifications/reducer'
import rankings from 'rankings/reducer'
import { combineReducers } from 'redux'
import { i18nState } from 'redux-i18n'
import isReportBugDialogOpen from 'ReportBugDialog/reducer'
import { reducer as search } from 'search'
import subListType from 'SubListTypeMenu/reducer'

import lastReFetchTime from './lastReFetchTime'
import ui from './ui'

export default (history: any) =>
  combineReducers({
    bugReport,
    channels,
    channelsFloorspaceModal,
    channelsType,
    clubCardModal,
    companies,
    completeness,
    componentsCompleteness,
    countries,
    countries1,
    datePicker,
    expanded,
    group,
    i18nState: i18nState as any,
    isListDetailsOpen,
    isReportBugDialogOpen,
    lastReFetchTime,
    myResults,
    notifications,
    omsOrigins,
    owners,
    rankings,
    router: connectRouter(history),
    saleTypes,
    search,
    store,
    storeDetails,
    stores,
    subListType,
    system,
    ui,
    user,
  })
